var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHunterArm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.6713 14.7554L32.8763 11.6774L36.0938 11.8889L44.9633 15.1634L45.8888 13.4204L54.3818 5.15238L56.5778 4.87338L58.1408 5.23938L59.1548 6.52488L59.0168 8.11788L53.0723 19.4294L58.3088 19.3769L60.9278 19.3454L62.7023 18.5849L66.9293 13.5509L82.6373 5.57688L85.5338 5.74638L87.1658 7.08888L87.7898 8.78538L86.6918 10.9814L85.5353 12.6704L96.9983 9.79788L99.4478 10.4999L100.643 12.0569L100.444 14.2679L99.4478 15.6914L87.1673 23.6954L89.6573 23.9789L92.5793 24.8054L95.1128 27.0674L96.0668 28.3814L95.7293 32.1914L88.3268 39.3899L89.1383 40.9379L88.8878 42.5699L87.9593 42.9929H85.1333L83.5808 43.1624L72.4103 47.1269L54.7208 48.3179L50.4548 53.1359L47.6753 55.2704L45.6398 54.7349L40.4873 56.7614L34.3778 57.8399H30.1043L23.5928 54.7334L24.4373 52.9589C24.4373 52.9589 26.9363 52.1984 29.6573 51.3119C32.3783 50.4254 33.1373 49.4969 33.1373 49.4969L36.0098 50.6789L38.0363 48.5669L36.5843 47.8064L32.8748 42.3344C32.8748 42.3344 31.0868 41.3894 30.5483 40.1219C30.0098 38.8544 29.6558 37.8404 29.6558 37.8404C29.6558 37.8404 28.0688 37.4099 27.8153 36.3584C27.5618 35.3069 27.0548 31.6259 27.5618 31.0589C28.0688 30.4919 29.6558 29.9984 29.6558 29.9984L25.3853 26.3069C25.3853 26.3069 23.8433 24.5054 23.8868 24.0779C23.9303 23.6504 23.8868 22.8629 23.8868 22.8629C23.8868 22.8629 23.7608 22.4684 24.4373 21.9614C25.1138 21.4544 29.2523 20.7404 29.2523 20.7404C29.2523 20.7404 27.8408 19.1624 26.7728 18.2819C25.7048 17.4014 24.2048 16.6139 24.1523 16.0364C24.0998 15.4589 24.6713 14.7554 24.6713 14.7554V14.7554Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1165 18.4274L66.466 23.8769",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7461 19.4729L62.3316 25.4984L68.7156 23.1599L69.3456 26.3069L72.4986 28.0154C72.4986 28.0154 73.5711 26.6669 75.2796 26.2169C76.9881 25.7669 82.7901 25.7129 84.0696 28.6634C84.0696 28.6634 84.4461 31.4324 83.7741 32.2424C83.7741 32.2424 80.3046 34.4009 79.6356 34.3109C78.9666 34.2209 80.7396 38.8184 80.7396 38.8184",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6377 34.3109C79.6377 34.3109 75.7317 34.9409 74.8317 34.3109C73.9317 33.6809 71.9667 33.5009 72.4992 28.0154",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3457 26.3083C69.3457 26.3083 63.4777 28.8703 61.6912 29.2078C59.9032 29.5454 56.5762 29.9998 56.5762 29.9998V35.9293C56.5762 35.9293 61.0732 37.4804 65.7487 38.8184C70.4242 40.1564 76.0237 43.3034 76.0237 43.3034",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8048 21.1528C35.8048 21.1528 37.3933 18.5518 38.0383 17.6188C38.6833 16.6858 37.8583 16.1968 36.9223 16.0378C35.9863 15.8773 34.9062 15.1828 34.9062 14.2708V11.7268",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0381 17.6189L38.2676 16.4399C38.2676 16.4399 39.2231 17.0024 39.9416 16.4399C40.6616 15.8774 41.5601 14.2739 39.9416 13.0514",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6738 12.9089L48.9908 11.7269H50.4533L52.8188 13.2629L53.9663 14.8844L52.9028 16.4399",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8186 13.2629L58.3086 7.0124L56.5761 5.5769L50.4531 11.7269",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.126 13.2629L67.939 14.0084L70.9615 12.6719L72.013 14.0579L75.541 18.7169",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7772 7.08887L72.0127 14.0579L74.2627 17.0309L85.5337 9.41987",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6699 41.9818C41.6699 41.9818 44.4569 39.9808 45.8084 40.1368C47.1599 40.2928 47.7509 40.0678 50.4539 39.4618C53.1569 38.8558 62.0744 37.5133 65.7494 38.8183",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4121 39.9269L42.0071 37.5014V33.7889C42.0071 33.7889 49.9466 31.5929 52.2281 32.3534C54.5096 33.1139 53.2421 38.8199 53.2421 38.8199",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3972 29.5513C34.3972 29.5513 34.2217 32.2678 34.9042 33.7048C35.5867 35.1418 37.1077 35.3938 37.1917 36.7453C37.2757 38.0968 37.1917 40.9408 37.1917 40.9408",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6572 30C29.6572 30 31.6672 31.839 29.6572 37.5015",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2959 21.8504V27.0689",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8164 20.949V28.6635",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.252 20.949V29.1465",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9219 21.8504V26.3084",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3789 22.8643V24.8068",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0938 50.6819C36.0938 50.6819 37.6148 55.2689 37.6988 57.1859",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5791 43.3034L88.3266 39.4619",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.166 17.6834C78.166 17.6834 80.8615 21.0074 81.2905 23.8364",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.178 15.1634L85.762 14.2709L87.4795 14.7554L89.3095 17.0309L90.154 19.4729L89.3935 20.7419L87.367 21.7934",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3269 15.3749L98.1744 11.7269",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6562 18.0313L99.4453 14.0083",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3437 14.8844C24.3437 14.8844 23.7617 16.3199 24.6062 17.0294C25.4507 17.7389 27.1398 18.2234 28.2378 19.3754C28.5933 19.7474 29.0898 20.2664 29.6568 20.7914C30.8418 21.8879 32.3328 23.0099 33.4758 22.8599L36.1788 21.8399L30.1638 27.1994L29.5053 29.9999C29.5053 29.9999 28.0292 30.3614 27.6272 31.0604C27.2252 31.7594 27.6272 35.8229 27.6272 35.8229C27.6272 35.8229 27.8163 37.3289 29.7588 37.5014C29.7588 37.5014 29.2518 39.9539 33.2222 42.5729L36.6858 47.7254L38.0373 48.4859L36.0948 50.6819L33.3918 49.4999C33.3918 49.4999 30.9422 50.8514 28.9142 51.6119C26.8862 52.3724 24.9438 52.7939 24.5223 52.9634C24.0993 53.1329 23.5938 54.9059 23.5938 54.9059L30.1818 58.1999C30.1818 58.1999 38.0373 57.7769 41.8383 56.4254C45.6393 55.0739 45.6393 54.6509 45.6393 54.6509L47.5817 55.3259C47.5817 55.3259 49.4402 54.2279 50.7077 52.8764C51.9752 51.5249 54.6782 48.3989 54.6782 48.3989C54.6782 48.3989 70.4732 47.0474 72.0782 47.3849L83.7347 43.2464L87.7893 43.1624L89.0568 42.5714C89.0568 42.5714 89.8173 41.2544 88.2963 39.4214L95.6447 32.0129L96.0678 28.5494C96.0678 28.5494 94.2092 24.7349 90.7457 24.1499C87.2822 23.5649 85.7627 23.6504 85.7627 23.6504L88.1283 22.9754L99.7847 15.3734C99.7847 15.3734 101.39 13.5149 100.46 11.5724C99.5312 9.62989 96.4893 9.96739 96.4893 9.96739L84.0722 13.2614L86.7752 11.0654L87.7037 8.78539C87.7037 8.78539 87.1127 6.33589 85.1702 5.57539H82.6367L67.2632 13.0934L62.8713 18.4964L60.9287 19.3754H53.0733L59.1542 7.85689C59.1542 7.85689 59.3238 5.78689 58.0563 5.15389C56.7888 4.52089 54.7202 5.15389 54.7202 5.15389L46.1463 13.0514C46.1463 13.0514 45.3858 14.0234 45.0903 15.1634C45.0903 15.1634 40.3173 12.6299 36.7278 11.9954C33.1383 11.3624 32.5473 11.7419 32.0823 11.8694C31.6173 11.9969 24.3437 14.8844 24.3437 14.8844V14.8844Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6568 20.7929C29.6568 20.7929 28.4493 20.6774 28.0278 20.7929C27.6063 20.9084 24.4383 21.9209 24.1428 22.2164C23.8473 22.5119 23.7633 23.1449 24.1428 23.5259C24.1428 23.5259 23.6778 24.2009 24.0588 24.9614C24.4398 25.7219 26.0253 26.6924 26.7738 27.5384C27.5223 28.3829 29.6583 29.5514 29.6583 29.5514",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1787 21.8414C36.1787 21.8414 39.8957 25.7369 41.3027 25.6799C42.7112 25.6229 45.1877 24.1499 46.0892 23.7614C46.9907 23.3714 48.7922 21.4919 48.8492 20.7419C48.9062 19.9934 49.3562 18.5279 48.2867 17.4029C47.2172 16.2779 45.0917 15.1649 45.0917 15.1649",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.901 16.266C46.901 16.266 49.1855 15.75 50.2565 16.266C51.3275 16.782 53.0719 19.3755 53.0719 19.3755L55.6624 24.834L51.9454 26.58L49.5245 26.2425C49.5245 26.2425 49.4705 25.737 48.9905 25.68C48.5105 25.623 42.1475 26.073 41.585 26.58C41.0225 27.087 39.7834 28.6065 38.8819 28.6635C37.9804 28.7205 36.4609 27.9315 35.5594 28.6635C34.6579 29.3955 33.758 30 33.758 30C33.758 30 33.026 29.34 33.758 28.101C34.49 26.862 35.279 25.3455 36.179 25.146C37.079 24.9465 38.4544 23.9895 38.4544 23.9895",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3063 14.2709L67.3188 15.5999L68.6703 15.1634L70.4718 17.5709L69.8523 18.7529L71.3733 20.7404L72.4998 20.4209L73.5138 21.8489C73.5138 21.8489 72.0498 22.4684 71.4303 22.5809C70.8108 22.6934 69.6843 22.8899 68.7843 23.0174C67.8843 23.1449 66.8703 23.7074 66.8703 23.7074L62.1723 25.6784C62.1723 25.6784 58.9863 25.5659 58.8183 25.4519C58.6503 25.3379 55.6653 24.8324 55.6653 24.8324",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5137 21.8504C73.5137 21.8504 81.0602 23.8769 81.5657 23.8769C82.0712 23.8769 85.7612 23.6519 85.7612 23.6519",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 20.4223L77.681 18.1348C77.681 18.1348 81.2285 14.8123 81.566 14.7568C81.9035 14.7013 82.58 15.0103 83.03 15.1648L83.48 15.3193L84.7745 15.1648L86.4635 17.1223L85.76 18.1363L86.4635 21.0088L87.4775 21.8533V22.8673",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1465 13.0515H48.116V14.271L50.2565 16.266L51.7205 15.7125L53.966 17.6835",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0374 48.4859L41.6419 45.8399C41.6419 45.8399 44.5699 48.3734 45.6964 49.0499C46.8229 49.7249 49.7104 52.8044 49.7509 53.2739C49.7914 53.7434 49.3189 54.1274 49.3189 54.1274",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2223 42.5729C33.2223 42.5729 32.7438 41.2214 32.9133 40.9394C33.0828 40.6574 34.0953 39.9254 34.0953 39.9254C34.0953 39.9254 36.2913 40.9949 36.6858 40.9949C37.0803 40.9949 39.6708 40.7129 40.4028 41.2484C41.1348 41.7839 43.3878 43.0229 43.3878 43.0229C43.3878 43.0229 46.1478 43.6424 48.2313 44.0369C50.3148 44.4314 52.3983 44.8814 52.3983 44.8814L54.3123 45.1064C54.3123 45.1064 55.2693 45.9509 55.3263 46.5149C55.3833 47.0789 54.6783 48.4019 54.6783 48.4019",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0771 47.3879C72.0771 47.3879 76.1031 44.2619 76.5546 43.6994C77.0061 43.1369 76.5546 42.2909 77.7936 41.2214C79.0326 40.1519 84.5511 35.7029 86.1276 34.9139C87.7041 34.1249 95.4756 31.5359 95.4756 31.5359",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8818 28.6634C38.8818 28.6634 39.3888 31.1699 39.3888 32.2679C39.3888 33.3659 38.6283 37.9274 38.8818 38.5184C39.1353 39.1094 39.1098 40.9394 39.1098 40.9394",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6357 5.5769L86.7757 11.0669",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7188 5.1539C54.7188 5.1539 57.3797 4.9844 59.1527 7.8569",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4873 9.96899C96.4873 9.96899 100.458 10.8135 99.7813 15.375",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0719 13.2629L81.5654 14.7554",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterArm);
export default __webpack_public_path__ + "static/media/Hunter Arm.3239973ef4af1cd5d82e01aae15b5291.svg";
export { ForwardRef as ReactComponent };